// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getStoryWithParentProps = (data: any, parentProps: Record<string, string>) => ({
  story: {
    ...data.story,
    content: {
      ...data.story.content,
      parentProps,
    },
  },
});
